import { InsStatus } from "cnam/types/types";
import { State } from "./abstract/cnam-context";
import InsWithConfirmationRetrievalContext from "./ins-with-confirmation-retrieval-context";
export default class InsWithConfirmationAndSuccessRetrievalContext extends InsWithConfirmationRetrievalContext {
  constructor(cnamAdapterName, patient, authenticationContext, insiAdapter, dmpAdapter, store, requestManager, onSuccess) {
    super(cnamAdapterName, patient, authenticationContext, insiAdapter, dmpAdapter, store, requestManager, "insi", onSuccess);
    this.states = [...this.states, new State("show-success", () => {
      return Promise.resolve((this.patient.insStatus == InsStatus.Qualified || this.patient.insStatus == InsStatus.Recovered) && !this.insProcessNeeded && this.identitySaved);
    }, async () => {
      await this.store.createRecord("cnam-process-ended-journal-event", {
        timedTransactions: this.timedTransactions,
        occurredAt: new Date(),
        patient: this.patient,
        cnamProcessStartedJournalEvent: this.cnamProcessStartedJournalEvent
      }).save();
      this.successKey = "ins";
    })];
  }
  reset() {
    super.reset();
    this.successKey = undefined;
  }
}